import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bhuach9k: FaireBrandEntity = {
  token: "b_bhuach9k",
  type: "brand",
  name: "Boss Dotty Paper Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/dac37fe70832b853002009b465329709b42486052616f48674fc6fb50b3c93fa.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/81713ec00f4f1922e32827c5366a3b1ebfe954c1a75b02467051a97c76ec9051.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/dac37fe70832b853002009b465329709b42486052616f48674fc6fb50b3c93fa.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/81713ec00f4f1922e32827c5366a3b1ebfe954c1a75b02467051a97c76ec9051.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 130,
  isTopShop: true,
  isInsider: true,
  description:
    "Boss Dotty is a stationery and gift company celebrating the everyday, with fingers crossed. Our playfully illustrated products are inspired by the tiniest moments — romanticizing the perfectly toasted bagel, expert typography on a fading street sign, or an inside joke from a friend who has seen it all.\n \nWe aim to bring flashes of joy via ephemeral art on ordinary objects as a respite in an increasingly chaotic world. Through a joyful, maximalist reimagination of the everyday, our goods invite small moments of connection and a space where people can feel seen.\n\nOur products are designed and packaged by hand by a tiny team in Greenpoint, Brooklyn, with lots of love and attention to detail. Theresa Berens is the founder and creative director behind Boss Dotty, a labor of love that would not be possible without pop-in help from a wildly supportive band of family and friends in Brooklyn and Nebraska. Her creative, independent and resilient grandmother Dorothy is Boss Dotty’s namesake. \n\nBoss Dotty goods have appeared in more than 1,000 stores globally. Select retailers include museum shops at MoMA PS1, The Whitney Museum, The National Museum of Women In The Arts and The Brooklyn Museum; iconic bookstores like The Strand, Powell’s Books and the New York Public Library Shop; and national retailers including Barnes & Noble, Paper Source, Urban Outfitters, Anthropologie, and Trader Joe’s.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:09.012Z",
    importedBy: "entity-db-cli",
  },
};
